class LocalRepo {
  static init() {
    return new LocalRepo()
  }

  async save(data) {
    const dataToSave = JSON.stringify(data)
    window.localStorage.setItem('user:userData', dataToSave)
  }

  async delete() {
    const user = await this.get()
    window.localStorage.removeItem('user:userData')
    return user || null
  }

  async get() {
    const data = window.localStorage.getItem('user:userData')
    try {
      return JSON.parse(data)
    } catch (error) {
      console.log('🚀 ~ LocalRepo ~ get ~ error:', error)
      return null
    }
  }
}

export default LocalRepo
